import styled, { css } from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";

export const StyledField = styled.div`
    display: inline-flex;
    user-select: none;
`;

export const StyledSegment = styled.div`
    ${TEXT_VARIANT_STYLES.Body_1_1}

    ${(props) =>
        props.isSmallSize &&
        css`
            ${TEXT_VARIANT_STYLES.Body_2_1}
        `}

    text-align: center;

    &:focus {
        color: ${COLOR_VALUES.Black};
        background: ${COLOR_VALUES.Gray_5};
        outline: none;
        border-radius: 2px;
    }

    ${(props) =>
        props.isPlaceholder || props.disabled
            ? css`
                  color: ${COLOR_VALUES.Gray_4};
              `
            : css`
                  color: ${COLOR_VALUES.Black};
              `}

    ${(props) =>
        props.disabled &&
        css`
            user-select: none;
        `}
`;
